import { useQuery } from '@tanstack/react-query';

import { fetchSearchTerminationSimulations } from '@octopus/termination-api';
import {
  DataGridProps,
  prepareDataGridSearchInput,
} from '@octopus/ui/data-grid';

export const useSearchSimulations = ({
  organizationId,
  activeTab,
  dataGridProps,
}: {
  organizationId: string;
  activeTab: string;
  dataGridProps: DataGridProps;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['simulations'],
    queryFn: () =>
      fetchSearchTerminationSimulations({
        pathParams: {
          organizationId,
        },
        body: prepareDataGridSearchInput(dataGridProps),
      }),
    enabled: !!organizationId && activeTab === 'simulations',
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { data, isLoading };
};
